(function () {
  var STORAGE_KEY = 'grant-blanc-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
    updateWishlistUI();
    document.dispatchEvent(new CustomEvent('gb:wishlist:updated', { detail: { items: items } }));
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function addToWishlist(product) {
    var wishlist = getWishlist();
    if (!wishlist.some(function (item) { return item.handle === product.handle; })) {
      wishlist.push(product);
      saveWishlist(wishlist);
    }
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (item) { return item.handle !== handle; }));
  }

  function toggleWishlist(product) {
    if (isWishlisted(product.handle)) {
      removeFromWishlist(product.handle);
    } else {
      addToWishlist(product);
    }
  }

  function updateWishlistUI() {
    var wishlist = getWishlist();
    var handles = {};
    wishlist.forEach(function (item) {
      handles[item.handle] = true;
    });

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = !!handles[handle];
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;
    });

    document.querySelectorAll('[data-wishlist-bubble]').forEach(function (el) {
      el.classList.toggle('visually-hidden', wishlist.length === 0);
    });

    document.querySelectorAll('.gb-wishlist-navbar-icon').forEach(function (el) {
      el.classList.toggle('gb-wishlist-navbar-icon--has-items', wishlist.length > 0);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var product = {
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price')
    };

    if (!product.handle) return;
    toggleWishlist(product);
  });

  document.addEventListener('DOMContentLoaded', updateWishlistUI);
  document.addEventListener('shopify:section:load', updateWishlistUI);
  document.addEventListener('cart:update', updateWishlistUI);

  // The header markup gets replaced/re-rendered asynchronously by the theme
  // whenever the cart changes (e.g. after Add to cart), which wipes this
  // badge back to its default markup shortly after our own update runs.
  // Watch the header for that replacement and repaint the instant it
  // happens, instead of guessing at a delay (which causes a visible flash).
  function observeHeaderForWishlistReset() {
    var target = document.querySelector('header-actions') || document.querySelector('#header-component');
    if (!target || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      observer.disconnect();
      updateWishlistUI();
      observer.observe(target, { childList: true, subtree: true });
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeaderForWishlistReset);
  } else {
    observeHeaderForWishlistReset();
  }

  window.gbWishlist = {
    getWishlist: getWishlist,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    toggleWishlist: toggleWishlist,
    isWishlisted: isWishlisted,
    updateWishlistUI: updateWishlistUI
  };

  updateWishlistUI();
})();
